import { c as _c } from "react/compiler-runtime";
import { MembersDuoIcon, SearchDuoIcon } from "@flat-ui";
import { EmptyPage } from "@src/components/common/empty-page/empty-page";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
/** Empty page content for members page */
export function MembersEmptyPage(t0) {
  const $ = _c(4);
  const {
    subtitle,
    button
  } = t0;
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  if (debouncedSearchText.length) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyPage title="No results found" subtitle="There are no members that match this search." icon={SearchDuoIcon} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  } else {
    let t1;
    if ($[1] !== button || $[2] !== subtitle) {
      t1 = <EmptyPage title="You don't have any members yet" subtitle={subtitle} icon={MembersDuoIcon} button={button} />;
      $[1] = button;
      $[2] = subtitle;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
}